// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y4cd","question":"styles_question__393tM","description":"styles_description__2Fz-D"};